import { loginRequest, logoutRequest } from "../../services/requests/auth";
import store from "../../store";
import { $snack } from "../../services/snack";
import router from "../../router/";

const state = {
  token: localStorage.getItem("token"),
};

const getters = {
  getIsLogged(state) {
    return !!state.token;
  },
  getToken(state) {
    return state.token;
  },
};

const mutations = {
  SET_TOKEN(state, payload) {
    state.token = payload;
  },
  LOGIN(state, payload) {
    store.dispatch("setUser", payload);
    let address = null;
    if (payload.address) {
      address = {
        ...payload.address,
        num: payload.address.number,
        additional_detail: payload.address.complement,
      };
    }
    store.dispatch("setAddress", address);
    localStorage.setItem("token", payload.access_token);
    state.token = payload.access_token;
    $snack.success("Login realizado com sucesso!");
    router.push({ name: "dashboard" });
  },
  LOGOUT(state) {
    logoutRequest()
      .then(() => {
        localStorage.clear();
        state.token = null;
        router.push({ name: "login" }).catch((err) => console.log(err));
        store.dispatch("setUser", null);
      })
      .catch((err) => console.log(err));
  },
};

const actions = {
  setToken({ commit }, payload) {
    commit("SET_TOKEN", payload);
  },
  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      loginRequest(payload)
        .then((res) => {
          commit("LOGIN", res.data);
          resolve();
        })
        .catch((err) => reject(err));
    });
  },
  logout({ commit }) {
    commit("LOGOUT");
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
